import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function ApplicationForm() {
  return <div className="min-h-screen bg-white flex flex-col font-sans" data-id="element-585">
      <Navigation data-id="element-586" />

      <main className="flex-grow pt-32 px-4 sm:px-6 lg:px-8" data-id="element-587">
        <iframe src="https://dashboard.b2systems.io/apps/UFs1gT7hJQZ8A9zk85dFemX1VqV2" className="w-full border-0" style={{
        minHeight: '800px'
      }} allow="forms" sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation" title="Business Funding Application" data-id="element-588" />
      </main>

      <Footer data-id="element-589" />
    </div>;
}